import type { ObrasCardsColumn } from "../obras-cards";

/** Visões do quadro de Cards: por status da obra ou por status financeiro (Figma obras-cards 10720:716820). */
export type ObrasCardsVisao = "obra" | "financeiro";

/**
 * Ordem e rótulo das colunas da visão Obra (Status=Obra 12699:201902), na ordem do Figma; o código é o do status da obra.
 * As colunas vêm dos status da API: status fora desta lista entra depois destes, com a descrição da API.
 */
export const OBRAS_CARDS_COLUNAS_OBRA: readonly ObrasCardsColumn[] = [
  { code: "EM_PLANEJAMENTO", label: "Em Planejamento" },
  { code: "PLANEJAMENTO_MACRO", label: "Planejamento Macro" },
  { code: "PLANEJAMENTO_DETALHADO", label: "Planejamento Detalhado" },
  { code: "PLANEJAMENTO_EXECUTIVO", label: "Planejamento Executivo" },
  { code: "EXECUCAO", label: "Execução" },
  { code: "FINALIZADA", label: "Finalizada" },
  { code: "EM_OPERACAO", label: "Em Operação" },
  { code: "ON_HOLD", label: "On Hold" },
];

/**
 * Colunas da visão Financeiro (Status=Financeiro 713:29624, column 713:29513), na ordem do Figma; o código é o do status
 * financeiro. Pronta para a tela de Financeiro, que ainda não existe.
 */
export const OBRAS_CARDS_COLUNAS_FINANCEIRO: readonly ObrasCardsColumn[] = [
  { code: "FEL_0", label: "FEL-0" },
  { code: "FEL_1", label: "FEL-1" },
  { code: "FEL_2", label: "FEL-2" },
  { code: "FEL_3", label: "FEL-3" },
  { code: "FEL_4", label: "FEL-4" },
  { code: "EXECUCAO", label: "Execução" },
  { code: "FECHAMENTO", label: "Fechamento" },
  { code: "CONCLUIDA", label: "Concluída" },
];

export const OBRAS_CARDS_COLUNAS: Record<ObrasCardsVisao, readonly ObrasCardsColumn[]> = {
  obra: OBRAS_CARDS_COLUNAS_OBRA,
  financeiro: OBRAS_CARDS_COLUNAS_FINANCEIRO,
};
